import Helpers from '@helpers';
import * as React from 'react';
import { State } from './model';
import './style.css';

class Welcome extends React.Component<{}, State> {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    public componentDidMount() {
        this.setInitialVisibility();
    }

    public render() {
        return (
            <div className={this.resultHasValue() ?'welcome result':this.state.formVisible ? 'welcome visible' : 'welcome'} style={{ display: this.getDisplayStyle() }}>
                <div className="content">
                    <h6>این تخفیف لازمت میشه</h6>
                    <button onClick={this.hideWelcome} className="close" type="button">x</button>
                    <button style={{ display: this.state.formVisible ? 'none' : 'inline-block' }} onClick={this.showForm} className="action" type="button">بزن بریم</button>
                    <div className="form">
                        <div>
                            <input
                                style={{ border: this.state.firstNameValid ? 'none' : '1px solid red' }}
                                title={ this.state.firstNameValid ? '' : 'وارد کردن نام به شکل صحبح و با حروف فارسی الزامی است'}
                                value={this.state.firstName}
                                onChange={this.handleChangeFirstName}
                                type="text" placeholder="نام" name="firstName" id="firstName" />
                            <input
                                style={{ border: this.state.lastNameValid ? 'none' : '1px solid red' }}
                                title={this.state.lastNameValid ? '' : 'وارد کردن نام خانوادگی به شکل صحبح و با حروف فارسی الزامی است'}
                                value={this.state.lastName}
                                onChange={this.handleChangeLastName}
                                type="text" placeholder="نام خانوادگی" name="lastName" id="lastName" />
                        </div>
                        <input
                            style={{ border: this.state.mobileValid ? 'none' : '1px solid red' }}
                            title={this.state.mobileValid ? '' : 'وارد کردن شماره تماس به شکل صحیح الزامی است'}
                            value={this.state.mobile}
                            onChange={this.handleChangeMobile}
                            type="text" placeholder="شماره تماس" name="mobiel" id="mobile" required />
                        <input
                            style={{ border: this.state.emailValid ? 'none' : '1px solid red' }}
                            title={this.state.emailValid ? '' : 'وارد کردن ایمیل به شکل صحیح الزامی است'}
                            value={this.state.email}
                            onChange={this.handleChangeEmail}
                            type="text" placeholder="ایمیل" name="email" id="email" required />
                        <button onClick={this.save} disabled={this.state.loading} className="save" type="button">ذخیره</button>
                    </div>
                    <div className={this.getResultClass()}>
                        <p>{this.getResultMessage()}</p>
                    </div>
                </div>
                <div className="middle"><span></span></div>
                <div className="banner">
                    <span>50 هزار تومان</span>
                </div>
            </div>
        );
    }

    private getInitialState = (): State => {
        
        return ({
            visible: false,
            formVisible: false,
            firstNameValid: true,
            lastNameValid: true,
            emailValid: true,
            mobileValid: true,
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            loading: false,
            errorMessage: "",
            successMessage: ""
        });
    };

    private setInitialVisibility() {
        Helpers.ApiHelper.isFirstTimeUser()
            .done((data) => {
                var visible = data;
                var setting = localStorage.getItem("WelcomeModal.Close");
                if (setting) {
                    visible = !(setting === "true");
                }
                this.setState({
                    visible: visible
                });
            });
    }

    private resultHasValue = (): boolean => this.state.successMessage !== "" || this.state.errorMessage !== "";
    private getResultMessage = (): string => this.state.successMessage !== "" ? this.state.successMessage : this.state.errorMessage;
    private getResultClass = (): string => this.state.successMessage !== "" ? "result success" : "result error";

    private save = () => {
        var isValid = this.validate();
        if (isValid) {
            this.setState({
                loading: true
            });

            var xhr = Helpers.ApiHelper.addNewSubscriber(
                this.state.firstName,
                this.state.lastName,
                this.state.mobile,
                this.state.email);

            xhr.done(() => {
                    localStorage.setItem("WelcomeModal.Close", "true");
                    this.setState({
                        successMessage:
                            'اطلاعات شما با موفقیت ثبت شد. کد تخفیف همراه اطلاعات تکمیلی از طریق ایمیل ارسال خواهد شد.'
                    });
                })
                .fail(_ => {
                    if (xhr.status === 406) {
                        this.setState({
                            errorMessage:
                                'شما قبلا از سایت مقداد آی تی خرید کرده اید. منتظر پیشنهادات و تخفیف های هیجان انگیز بعدی ما باشید'
                        });
                    } else {
                        this.setState({
                            errorMessage: 'خطایی رخ داده است، لطفا مجددا سعی نمائید.'
                        });
                    }
                })
                .always(_ => {
                    this.setState({
                        loading: false
                    });
                });
        }
    };

    private validate = (): boolean => {

        var firstNameValid = this.state.firstName.match(/^[آ-ی\s]+$/) != null;
        var lastNameValid = this.state.lastName.match(/^[آ-ی\s]+$/) != null;
        var mobileValid= this.state.mobile.match(/^09[0-9]{9}$/) != null;
        var emailValid = this.state.email.match(/^.+\@.+\..+$/) != null;

        this.setState({
            firstNameValid: firstNameValid,
            lastNameValid: lastNameValid,
            mobileValid: mobileValid,
            emailValid: emailValid
        });

        return firstNameValid && lastNameValid && mobileValid && emailValid;
    }

    private getDisplayStyle = () => this.state.visible ? 'block' : 'none';

    private hideWelcome = () => {
        localStorage.setItem("WelcomeModal.Close", "true");
        this.setState({
            visible: false
        });
    };

    private showForm = () => {
        this.setState({
            formVisible: true
        });
    };

    private handleChangeFirstName = event => {
        this.setState({
            firstName: event.target.value,
            firstNameValid: event.target.value.match(/^[آ-ی\s]+$/) != null
        });
    }

    private handleChangeLastName = event => {
        this.setState({
            lastName: event.target.value,
            lastNameValid: event.target.value.match(/^[آ-ی\s]+$/) != null
        });
    }

    private handleChangeEmail = event => {
        this.setState({
            email: event.target.value,
            emailValid: event.target.value.match(/^.+\@.+\..+$/) != null
        });
    }

    private handleChangeMobile = event => {
        this.setState({
            mobile: event.target.value,
            mobileValid: event.target.value.match(/^09[0-9]{9}$/) != null
        });
    }
}

Helpers.ReactHelper.createReactElement('Welcome', Welcome);
